import * as React from 'react';

import classnames from 'classnames';

import {ErrorState} from 'shells/error-state/error-state';
import {MiniMap} from 'shells/mini-map/mini-map';
import {UppercaseLabel} from 'shells/typography/uppercase-label';

import type {
    EditionStubFragment as DripEdition,
    EditionStubFragment as DripEditionStub,
    TimespanInput,
} from 'nutshell-graphql-types';

import {NewEditionModal} from '../../editions/new-edition-modal';

import styles from './drip-sequence-mini-map-sidebar.module.css';

type Props = {
    selectedEditionId: string;
    dripSequenceId: string;
    editions: DripEdition[];
    error: string | null | undefined;
    isLoading: boolean;
    onEditionChange: (newEditionId: string) => void;
    onUpdateEdition: (arg1: {editionId: string; delay: TimespanInput}) => Promise<any>;
    onCreateEdition: (name: string, campaignId: string) => Promise<any>;
    onDuplicateEdition: (editionId: string, campaignId: string, name: string) => Promise<any>;
    editionsList: DripEditionStub[];
    canAddNewEdition: boolean;
};

export function DripSequenceMiniMapSidebar(props: Props) {
    const [isAddingEdition, setIsAddingEdition] = React.useState<boolean>(false);

    return (
        <>
            <div
                className={classnames(
                    styles['drip-sequence-mini-map-sidebar'],
                    styles['border-top-left-8']
                )}
            >
                <UppercaseLabel>Drip messages</UppercaseLabel>
                {props.error ? (
                    <ErrorState errorMessage={props.error} size='small' />
                ) : (
                    <div className={styles['mini-map-container']}>
                        {props.editions ? (
                            <MiniMap
                                editions={props.editions.map((edition) => {
                                    return {
                                        id: edition.id,
                                        name: edition.name,
                                        emailTemplate: {
                                            thumbnailUrl: edition.emailTemplate
                                                ? edition.emailTemplate.thumbnailUrl
                                                : undefined,
                                        },
                                        delay: edition.delay,
                                        status: edition.status,
                                        backgroundColor: edition.backgroundColor,
                                    };
                                })}
                                selectedId={props.selectedEditionId}
                                onSelectMessage={(editionId) => {
                                    setTimeout(() => {
                                        props.onEditionChange(editionId);
                                    }, 1);
                                }}
                                onAddMessage={
                                    props.canAddNewEdition
                                        ? () => setIsAddingEdition(true)
                                        : undefined
                                }
                                isLoading={props.isLoading}
                                onUpdateEdition={props.onUpdateEdition}
                            />
                        ) : undefined}
                    </div>
                )}
            </div>
            {props.canAddNewEdition && isAddingEdition ? (
                <NewEditionModal
                    type='dripSequenceEditions'
                    isOpen={isAddingEdition}
                    onClose={() => {
                        setIsAddingEdition(false);
                    }}
                    campaignId={props.dripSequenceId}
                    dripSequenceId={props.dripSequenceId}
                    dripSequenceEditions={props.editionsList}
                    onCreateEdition={props.onCreateEdition}
                    onDuplicateEdition={props.onDuplicateEdition}
                    // @ts-expect-error
                    defaultView='dripMessage'
                />
            ) : undefined}
        </>
    );
}
